/* Pooch - keeps the "Benefits / Offers / Details / Similar" bar under the sticky header.
   The CSS can only guess the header height. On phones the header is taller than that
   guess (logo row + search row) and the announcement bar scrolls away while you read,
   so the height keeps changing. This measures the real sticky header on every scroll
   and drops the tab bar right below it. It touches nothing else on the page. */
(function () {
  var nav = null;
  var ro = null;
  var ticking = false;
  var lastTop = -1;

  function stickyHeaderBottom() {
    var bottom = 0;
    var els = document.querySelectorAll('[class*="shopify-section-group-header-group"]');
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      var pos = getComputedStyle(el).position;
      if (pos !== 'sticky' && pos !== 'fixed') continue;
      var rect = el.getBoundingClientRect();
      if (!rect.height) continue;
      if (rect.top > window.innerHeight * 0.4) continue; /* not pinned to the top */
      if (rect.bottom > bottom) bottom = rect.bottom;

      /* The bar inside can reach lower than its own section: on phones the search line
         sits on a band with negative side margins. Measure what is actually drawn. */
      var inner = el.querySelectorAll('header-component.header, .header__underlay, .header__row--top .search-action');
      for (var j = 0; j < inner.length; j++) {
        var ir = inner[j].getBoundingClientRect();
        if (!ir.height) continue;
        if (ir.top > window.innerHeight * 0.4) continue;
        if (ir.bottom > bottom) bottom = ir.bottom;
      }
    }
    return bottom;
  }

  function place() {
    ticking = false;
    if (!nav) nav = document.querySelector('.pooch-ptabs');
    if (!nav) return;

    var bottom = stickyHeaderBottom();
    /* Nothing pinned, or a silly value - leave the stylesheet in charge. */
    if (bottom <= 0 || bottom > window.innerHeight * 0.5) {
      if (lastTop !== -1) {
        nav.style.top = '';
        lastTop = -1;
      }
      return;
    }

    var top = Math.round(bottom) - 1;
    if (top === lastTop) return;
    lastTop = top;
    nav.style.top = top + 'px';
  }

  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(place);
  }

  /* The header grows back (search row) with an animation that finishes after the
     scroll event, so watching scroll alone is not enough - watch its size too. */
  function watchHeader() {
    var els = document.querySelectorAll('[class*="shopify-section-group-header-group"]');
    for (var i = 0; i < els.length; i++) {
      els[i].addEventListener('transitionend', onScroll);
      if (window.ResizeObserver) {
        if (!ro) ro = new ResizeObserver(onScroll);
        ro.observe(els[i]);
      }
    }
  }

  function start() {
    place();
    watchHeader();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    /* The tab bar is built by script after load, so watch for it appearing. */
    if (window.MutationObserver) {
      var mo = new MutationObserver(function () {
        if (!nav) {
          nav = document.querySelector('.pooch-ptabs');
          if (nav) place();
        }
      });
      mo.observe(document.body, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
